import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/tabbed-card/tabbed-card.js';
      

      export interface Props {
     nTabs?: number;
     selectedTab?: number;
     hasDefaultSlotOnly?: boolean;
     hasTabIcons?: boolean
   }

      
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcTabbedCard',
  props: {
    nTabs: {},
    selectedTab: {},
    hasDefaultSlotOnly: { type: Boolean },
    hasTabIcons: { type: Boolean }
  },
  emits: ["tab-change"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onTabChange: (event: CustomEvent<{tab:number}>) => emit('tab-change', event as CustomEvent<{tab:number}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-tabbed-card',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})